import React, { useEffect, useState } from 'react';
import { Wrench } from 'lucide-react';
import { Button } from './ui/Button';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-brand-dark/95 backdrop-blur-md border-b border-brand-border shadow-lg' : 'bg-transparent'}`} data-id="element-128">
      <div className="container mx-auto px-4 md:px-6 flex items-center justify-between h-14" data-id="element-129">
        <div className="flex items-center gap-2" data-id="element-130">
          <Wrench className="w-5 h-5 text-brand-yellow" data-id="element-131" />
          <span className="text-lg font-bold tracking-wide text-white" data-id="element-132">
            SABER-DIGITAL
          </span>
        </div>
        <Button size="sm" onClick={() => document.getElementById('pricing')?.scrollIntoView({
        behavior: 'smooth'
      })} data-id="element-133">
          COMPRAR AHORA
        </Button>
      </div>
    </header>;
}